import React, { Fragment, useState, useEffect } from 'react';
import { getRequest, getStandardDate, postRequest } from '../../globalhelper/helper';
import { Box, Button, Container, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, Grid, IconButton, InputLabel, MenuItem, Paper, Select as MuiSelect, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableFooter, TextField, Typography, CircularProgress, Tooltip, Autocomplete, Fab, Zoom, Alert, AlertTitle } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import { connect } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SouthIcon from '@mui/icons-material/South';
import NorthIcon from '@mui/icons-material/North';
import { v4 as uuidv4 } from 'uuid';
const convertToINRs = number => {
  const roundedNumber = Math.floor(Number(number));
  const num = roundedNumber.toLocaleString("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0
  });
  return num;
};
const calculateTotalAmountValue = (array, key) => {
  return array.reduce((total, item) => total + (parseFloat(item[key]) || 0), 0);
};
const calculateTotalAmount = (array, key) => {
  const val = calculateTotalAmountValue(array, key);
  return convertToINRs(val);
};
const EmployeeCostSplitup = props => {
  const [tableData, setTableData] = useState([]);
  const [companyName, setCompanyName] = useState([]);
  const [dropdownDepartment, setDropdownDepartment] = useState([]);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [showError, setShowError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showScrollButton, setShowScrollButton] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [selectedDate, setSelectedDate] = useState(moment());
  const [showpopup, setShowpopup] = useState(false);
  const [previousMonthData, setPreviousMonthData] = useState([]);
  const [formData, setFormData] = useState({
    company: "",
    fromDate: "",
    toDate: "",
    department: ""
  });
  const handleDateChange = newValue => {
    setSelectedDate(newValue);
  };
  useEffect(() => {
    if (selectedDate && selectedDate.isValid()) {
      const startDate = selectedDate.clone().startOf('month').toDate();
      const endDate = selectedDate.clone().endOf('month').toDate();
      console.log(getStandardDate(startDate), getStandardDate(endDate));
      setFormData(prev => {
        return {
          ...prev,
          fromDate: getStandardDate(startDate),
          toDate: getStandardDate(endDate)
        };
      });
    }
  }, [selectedDate]);
  useEffect(() => {
    getRequest(`api/edureka/getCompanyAssignedToUser`).then(response => {
      const responseData = response.res.data;
      const orgname = responseData.map(item => item.orgname);
      setCompanyDetails(responseData);
      setCompanyName(orgname);
    });
  }, []);
  useEffect(() => {
    getRequest(`api/edureka/getUniqueDepartmentsForEC`).then(response => {
      const responseData = response.res.data;
      const department = responseData.map(item => item.department);
      const filteredDepartment = department.filter(item => item !== ' ');
      setDropdownDepartment(filteredDepartment);
    });
  }, []);
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => {
      return {
        ...prev,
        [name]: value
      };
    });
  };
  const handleReset = () => {
    setFormData({
      fromDate: '',
      toDate: '',
      company: '',
      department: ''
    });
    setSelectedDate(moment());
    setTableData([]);
    setLoading(false);
    setShowError(false);
  };
  const handleSubmit = () => {
    const {
      fromDate,
      toDate,
      company,
      department
    } = formData;
    if (fromDate && toDate && company && department) {
      setLoading(true);
      setShowError(false);
      setTableData([]);
      const id = companyDetails.filter(item => item.orgname === company);
      const companyid = id.map(item => item.orgid);
      const request = {
        fromDate,
        toDate,
        company: companyid[0],
        department
      };
      postRequest(`api/edureka/getEmployeeCostSplitup`, request).then(response => {
        const responseData = JSON.parse(response.res.data);
        if (responseData.length) {
          setTableData(responseData);
          setLoading(false);
        } else {
          setLoading(false);
          setShowError(true);
          setShowpopup(true);
          setErrorMessage("No data found, please try some other combination");
        }
      }).catch(err => {
        setLoading(false);
        setShowError(true);
        // setShowpopup(true)
        setErrorMessage("Oops something went wrong!!");
      });
    } else {
      toast.error("Please select all the required fields", {
        theme: "colored"
      });
      setShowError(true);
      setErrorMessage("Please select all the required fields");
    }
  };
  useEffect(() => {
    const processData = async () => {
      const data = [...previousMonthData];
      for (const item of data) {
        const allPercentagesPresent = ['b2cpercentage', 'pgppercentage', 'b2bpercentage', 'elcpercentage', 'higheredpercentage', 'vlabspercentage', 'verandapercentage'].every(key => item[key] !== undefined && item[key] !== '');
        if (allPercentagesPresent) {
          await handlePerc(item, {
            target: {
              name: 'b2cpercentage',
              value: item.b2cpercentage
            }
          }, 'b2cAmount');
          await handlePerc(item, {
            target: {
              name: 'pgppercentage',
              value: item.pgppercentage
            }
          }, 'pgpAmount');
          await handlePerc(item, {
            target: {
              name: 'b2bpercentage',
              value: item.b2bpercentage
            }
          }, 'b2bAmount');
          await handlePerc(item, {
            target: {
              name: 'elcpercentage',
              value: item.elcpercentage
            }
          }, 'elcAmount');
          await handlePerc(item, {
            target: {
              name: 'higheredpercentage',
              value: item.higheredpercentage
            }
          }, 'higheredAmount');
          await handlePerc(item, {
            target: {
              name: 'vlabspercentage',
              value: item.vlabspercentage
            }
          }, 'vlabsAmount');
          await handlePerc(item, {
            target: {
              name: 'verandapercentage',
              value: item.verandapercentage
            }
          }, 'verandaAmount');
        }
      }
    };
    processData();
  }, [previousMonthData]);
  const handlePerc = async (val, e, amt) => {
    const {
      name,
      value
    } = e.target;
    setTableData(prevTableData => {
      return prevTableData.map(item => {
        if (item.EmployeeID === val.EmployeeID) {
          const decimalPercentage = Number(value) / 100;
          const amount = Number(item.TotalSalary) * decimalPercentage;
          return {
            ...item,
            [name]: Number(value),
            [amt]: parseFloat(amount.toFixed(2))
          };
        } else {
          return item;
        }
      });
    });
  };
  const handlePercentage = (val, e, amt) => {
    const {
      name,
      value
    } = e.target;
    const data = [...tableData];
    const mappedData = data.map((item, index) => {
      if (item["EmployeeID"] === val["EmployeeID"]) {
        // console.log(index)
        if (index > 0) {
          const previousLine = index - 1;
          const previousItem = data[previousLine];
          const totalPercentageofPreviousItem = ['b2cpercentage', 'pgppercentage', 'b2bpercentage', 'elcpercentage', 'higheredpercentage', 'vlabspercentage', 'verandapercentage'].reduce((sum, key) => sum + (previousItem[key] || Number(0)), Number(0));

          // console.log(totalPercentageofPreviousItem)

          if (totalPercentageofPreviousItem !== 100) {
            toast.error("Please fill the above row correctly to proceed further", {
              theme: "dark"
            });
            return item;
          } else {
            const decimalPercentage = Number(value) / 100;
            const amount = Number(item.TotalSalary) * decimalPercentage;
            const updatedItem = {
              ...item,
              [name]: Number(value),
              [amt]: parseFloat(amount.toFixed(2))
            };
            const totalPercentage = ['b2cpercentage', 'pgppercentage', 'b2bpercentage', 'elcpercentage', 'higheredpercentage', 'vlabspercentage', 'verandapercentage'].reduce((sum, key) => sum + (updatedItem[key] || Number(0)), Number(0));

            // console.log(totalPercentage)

            if (totalPercentage > 100) {
              toast.error("Total percentage exceeds 100%. Please adjust the values", {
                theme: "colored"
              });
              return item;
            }

            // console.log(updatedItem)
            return updatedItem;
          }
        } else if (index === 0) {
          const decimalPercentage = Number(value) / 100;
          const amount = Number(item.TotalSalary) * decimalPercentage;
          const updatedItem = {
            ...item,
            [name]: Number(value),
            [amt]: parseFloat(amount.toFixed(2))
          };
          const totalPercentage = ['b2cpercentage', 'pgppercentage', 'b2bpercentage', 'elcpercentage', 'higheredpercentage', 'vlabspercentage', 'verandapercentage'].reduce((sum, key) => sum + (updatedItem[key] || Number(0)), Number(0));

          // console.log(totalPercentage)

          if (totalPercentage > 100) {
            toast.error("Total percentage exceeds 100%. Please adjust the values", {
              theme: "colored"
            });
            return item;
          }

          // console.log(updatedItem)
          return updatedItem;
        }
      } else {
        return item;
      }
    });
    setTableData(mappedData);
  };
  const scrollToBottom = () => {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth'
    });
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const handleScroll = () => {
    // Check if the user is close to the bottom of the page
    const isCloseToBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight;

    // Update the state to show or hide the scroll button
    setShowScrollButton(isCloseToBottom);
  };
  useEffect(() => {
    // Add event listener for scroll events
    window.addEventListener('scroll', handleScroll);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const getCurrentDateTime = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    const day = currentDate.getDate().toString().padStart(2, '0');
    const hours = currentDate.getHours().toString().padStart(2, '0');
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return formattedDateTime;
  };
  const getInPrdToTime = () => {
    const currentDate = new Date('2100-12-31');
    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    const day = currentDate.getDate().toString().padStart(2, '0');
    const hours = currentDate.getHours().toString().padStart(2, '0');
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return formattedDateTime;
  };
  const getFinancialYearAndMonth = (startDate, endDate) => {
    console.log(startDate, endDate);
    const startYear = new Date(startDate).getFullYear();
    const endYear = new Date(endDate).getFullYear();
    const startMonth = new Date(startDate).getMonth() + 1;
    const endMonth = new Date(endDate).getMonth() + 1;
    let financialYear, financialMonth;
    if (startMonth < 4) {
      financialYear = startYear - 1;
    } else {
      financialYear = startYear;
    }
    if (endMonth >= 4) {
      financialMonth = endMonth - 3;
    } else {
      financialMonth = endMonth + 9;
    }
    return {
      financialYear,
      financialMonth
    };
  };
  const getFinancialMonth = startDate => {
    const date = new Date(startDate);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    return `MTH_${year}_${month}`;
  };
  const handleUpload = () => {
    const inputData = [...tableData];
    const outputData = [];
    const validation = inputData.every((item, index) => {
      const totalPercentage = ['b2cpercentage', 'pgppercentage', 'b2bpercentage', 'elcpercentage', 'higheredpercentage', 'vlabspercentage', 'verandapercentage'].reduce((sum, key) => sum + (item[key] || Number(0)), Number(0));
      if (totalPercentage !== 100) {
        toast.error("Please fill the values correctly to proceed further", {
          theme: 'dark'
        });
        return false;
      } else {
        return true;
      }
    });

    // const amountValidation = inputData.every((item, index) => {
    //     const totalAmount = ['b2cAmount', 'b2bAmount', 'elcAmount', 'pgpAmount', 'higheredAmount', 'vlabsAmount', 'verandaAmount']
    //     .reduce((sum, key) => sum + (item[key] || 0), 0)

    //     const totalPercentage = ['b2cpercentage', 'pgppercentage', 'b2bpercentage', 'elcpercentage', 'higheredpercentage', 'vlabspercentage', 'verandapercentage']
    //         .reduce((sum, key) => sum + (item[key] || Number(0)), Number(0))

    //     if(totalPercentage > 0){
    //         if(totalAmount  (item['TotalSalary'] + 2)){
    //             toast.error("Please fill the values correctly to proceed further", {
    //                 theme: 'dark'
    //             });
    //             return false
    //         } else {
    //             return true
    //         }
    //     } else {
    //         return true
    //     }
    // })

    console.log(validation);
    if (validation) {
      const {
        fromDate,
        toDate,
        company,
        department
      } = formData;
      const result = getFinancialYearAndMonth(fromDate, toDate);
      const financialYear = `${result.financialYear}-${result.financialYear + 1}`;
      const financialMonth = getFinancialMonth(fromDate);
      console.log(financialYear, financialMonth);
      const id = companyDetails.filter(item => item.orgname === formData.company);
      const companyid = id.map(item => item.orgid);
      inputData.forEach(employee => {
        for (const key in employee) {
          if (key.endsWith("Amount") && employee[key] !== null) {
            const lobType = key.replace("Amount", "").toUpperCase();
            const outputObject = {
              "AllocationType": "%",
              "AmountInLocalCurrency": employee[key],
              "AmountInTransactionCurrency": null,
              "CostAllocatedDocumentValue": null,
              "CostAllocationMethod": employee["BusinessVertical"],
              "CostAllocationParameterPerc": employee[`${lobType.toLowerCase()}percentage`],
              "CostAllocationParameterValue": null,
              "CostAllocationValue": null,
              "CreatedID": employee["EmployeeID"],
              "CreatedBy": props.state.login.userData.USR_Name,
              "DocumentNumber": null,
              "DocumentRef": null,
              "DocumentValue": employee["TotalSalary"],
              "FinancialDate": null,
              "FinancialYear": financialYear,
              "ForPrdFrom": fromDate,
              "ForPrdTo": toDate,
              "Function": employee["Department"],
              "InPrdFrom": getCurrentDateTime(),
              "InPrdTo": getInPrdToTime(),
              "InterimID": null,
              "ItemID": null,
              "ItemName": null,
              "LOB": lobType,
              "LinKType": null,
              "LineID": null,
              "LinkRef": null,
              "LinkRef1": null,
              "LinkRef2": null,
              "LinkRef3": null,
              "MessageID": null,
              "Month": financialMonth,
              "OrgID": companyid[0],
              "OrigDocumentNumber": null,
              "OrigDocumentRef": null,
              "ReceiverAccount": companyid[0],
              "ReceiverName": company,
              "Reference1": null,
              "Reference2": null,
              "Reference3": null,
              "SenderAccount": null,
              "SenderName": null,
              "TransactionStatus": "Waiting For Approval",
              "TransactionType": "EmployeeCostSplitup",
              "Upload": null,
              "PK": "TY#EmployeeCostSplitup",
              "SK": `ID#${employee["EmployeeID"]}#FROMDT#${fromDate}#TODT#${toDate}#LOB#${lobType}`,
              "CheckSum": null,
              "TransactionID": uuidv4(),
              "Input": null,
              "Output": `ACTIVE/CA/ECSplitup/${companyid[0]}/${employee["EmployeeID"]}/FY_${financialYear}/${financialMonth}/CA_${companyid[0]}_${employee["EmployeeID"]}_FY_${financialYear}_${financialMonth}.json`
            };
            outputData.push(outputObject);
          }
        }
      });
      console.log(outputData);
      postRequest(`api/edureka/postEmployeeCostContributionArray`, outputData).then(response => {
        console.log(response.res.data);
        // toast.success("Uploaded Successfully")

        const request = {
          arr: inputData,
          period: financialMonth,
          department: department,
          date: fromDate,
          company: companyid[0]
        };
        postRequest(`api/edureka/postEmployeeContribution`, request).then(response => {
          console.log(response.res.data);
          toast.success("Uploaded Successfully");
          window.location.reload();
        }).catch(() => {
          toast.error("Oops something went wrong");
        });
        console.log(request);
      }).catch(err => {
        console.log(err);
        toast.error("Oops some problem with uploading, please try again after sometime");
      });
    }
  };
  const getPreviousMonthRange = fromDate => {
    const date = new Date(fromDate);

    // date.setMonth(date.getMonth() -1)

    const day = '01';
    const month = date.getMonth().toString().padStart(2, '0');
    const year = date.getFullYear();
    const startDate = `${year}-${month}-${day}`;
    return startDate;
  };
  const handlePopupSubmit = () => {
    setShowpopup(false);
    setLoading(true);
    setShowError(false);
    const {
      fromDate,
      company,
      department
    } = formData;
    const startDate = getPreviousMonthRange(fromDate);
    console.log(startDate);
    const id = companyDetails.filter(item => item.orgname === company);
    const companyid = id.map(item => item.orgid);
    const request = {
      fromDate: startDate,
      toDate: fromDate,
      company: companyid[0],
      department
    };
    postRequest(`api/edureka/getEmployeeCostSplitupForNonExisting`, request).then(response => {
      const responseData = JSON.parse(response.res.data);
      if (responseData.length) {
        setTableData(responseData);
        setLoading(false);
        setPreviousMonthData(responseData);
      } else {
        setLoading(false);
        setShowError(true);
        setErrorMessage("No data found, please try some other combination");
      }
    }).catch(err => {
      setLoading(false);
      setShowError(true);
      setErrorMessage("Oops something went wrong!!");
    });
  };
  const handleSalaryChange = (arr, e) => {
    const {
      name,
      value
    } = e.target;
    const data = [...tableData];
    const mappedData = data.map((item, index) => {
      if (item['EmployeeID'] === arr['EmployeeID']) {
        // const updatedItem = {...item, "TotalSalary": parseFloat(value)}
        const calculateAmount = handleAmt(value, item);
        const returnItem = {
          ...item,
          "TotalSalary": parseFloat(value),
          ...calculateAmount
        };
        return returnItem;
      } else {
        return item;
      }
    });
    setTableData(mappedData);
  };
  const handleAmt = (amt, item) => {
    console.log(amt);
    const obj = {
      "b2bAmount": parseFloat(amt) * (parseFloat(item.b2bpercentage) / 100),
      "b2cAmount": parseFloat(amt) * (parseFloat(item.b2cpercentage) / 100),
      "elcAmount": parseFloat(amt) * (parseFloat(item.elcpercentage) / 100),
      "pgpAmount": parseFloat(amt) * (parseFloat(item.pgppercentage) / 100),
      "higheredAmount": parseFloat(amt) * (parseFloat(item.higheredpercentage) / 100),
      "vlabsAmount": parseFloat(amt) * (parseFloat(item.vlabspercentage) / 100),
      "verandaAmount": parseFloat(amt) * (parseFloat(item.verandapercentage) / 100)
    };
    return obj;
  };
  return <LocalizationProvider dateAdapter={AdapterMoment}>
            <Container maxWidth="xl" sx={{
      py: 4
    }}>
            <Paper elevation={3} sx={{
        p: 3,
        mb: 4,
        borderRadius: 2
      }}>
                <Grid container spacing={3} alignItems="center">
                    <Grid item xs={12} sm={6} md={3}>
                        <Autocomplete size="small" options={companyDetails.sort((a, b) => a.orgname.localeCompare(b.orgname))} getOptionLabel={option => option.orgname} value={companyDetails.find(c => c.orgname === formData.company) || null} onChange={(event, newValue) => {
              handleChange({
                target: {
                  name: 'company',
                  value: newValue ? newValue.orgname : ''
                }
              });
            }} renderInput={params => <TextField {...params} label="Company" variant="outlined" fullWidth />} />
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <DatePicker views={['year', 'month']} label="Month and Year" minDate={moment('2023-01-01')} maxDate={moment('2030-12-31')} value={selectedDate} onChange={handleDateChange} renderInput={params => <TextField {...params} size="small" fullWidth variant="outlined" />} />
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <Autocomplete size="small" options={dropdownDepartment.sort()} value={formData.department || null} onChange={(event, newValue) => {
              handleChange({
                target: {
                  name: 'department',
                  value: newValue || ''
                }
              });
            }} renderInput={params => <TextField {...params} label="Department" variant="outlined" fullWidth />} />
                    </Grid>
                </Grid>

                <Box sx={{
          display: 'flex',
          justifyContent: 'center',
          mt: 3,
          gap: 2
        }}>
                    <Button variant="contained" color="success" onClick={handleSubmit}>Submit</Button>
                    <Button variant="contained" color="error" onClick={handleReset}>Reset</Button>
                    {tableData.length > 0 && <Button variant="contained" color="primary" onClick={handleUpload}>
                            Upload
                        </Button>}
                </Box>
            </Paper>

            <Divider sx={{
        mb: 4
      }} />

            {showError && <Box sx={{
        mb: 4
      }}>
                    <Alert severity='warning' sx={{
          borderRadius: 2
        }}>
                        <AlertTitle>No Data Found</AlertTitle>
                        {errorMessage || "There is no data to display at the moment."}
                    </Alert>
                </Box>}

            {loading && <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        py: 5
      }}>
                    <CircularProgress />
                </Box>}

            {!loading && tableData.length > 0 && <TableContainer component={Paper} elevation={3} sx={{
        maxHeight: 650,
        borderRadius: 2
      }}>
                    <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  {(tableData.sort((a, b) => a["EmployeeID"].localeCompare(b["EmployeeID"])) && tableData.sort((a, b) => a["EmployeeID"].localeCompare(b["EmployeeID"])).length > 0 ? Object.keys(tableData.sort((a, b) => a["EmployeeID"].localeCompare(b["EmployeeID"]))[0] || {}) : []).map((key, index) => <TableCell key={index} sx={{
                textAlign: 'left'
              }}><b>{key}</b></TableCell>)}
                </TableRow>
              </TableHead>
              <TableBody>
                {(tableData.sort((a, b) => a["EmployeeID"].localeCompare(b["EmployeeID"])) || []).map((row, rowIndex) => <TableRow key={rowIndex}>
                    {Object.entries(row || {}).map(([key, val], valIndex) => {
                let displayVal = val;
                if (typeof val === 'number' && !Number.isInteger(val)) {
                  displayVal = val.toFixed(2);
                } else if (typeof val === 'string' && !isNaN(val) && val.trim() !== '' && val.includes('.')) {
                  displayVal = parseFloat(val).toFixed(2);
                } else if (typeof val === 'boolean') {
                  displayVal = val ? 'Yes' : 'No';
                } else if (val === null || val === undefined) {
                  displayVal = '';
                } else if (typeof val === 'object') {
                  displayVal = JSON.stringify(val);
                }
                return <TableCell key={valIndex} sx={{
                  textAlign: 'left'
                }}>
                          {String(displayVal)}
                        </TableCell>;
              })}
                  </TableRow>)}
              </TableBody>
            </Table>
                </TableContainer>}

            <ToastContainer />

            <Box sx={{
        position: 'fixed',
        bottom: 32,
        right: 32,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        zIndex: 1100
      }}>
                <Zoom in={showScrollButton}>
                    <Fab color="primary" size="small" onClick={scrollToTop}>
                        <NorthIcon />
                    </Fab>
                </Zoom>
                <Zoom in={showScrollButton}>
                    <Fab color="primary" size="small" onClick={scrollToBottom}>
                        <SouthIcon />
                    </Fab>
                </Zoom>
            </Box>

            <Dialog open={showpopup} onClose={() => setShowpopup(false)}>
                <DialogTitle sx={{
          fontSize: '1.1rem'
        }}>
                    No data found, do you want to fetch from previous month?
                </DialogTitle>
                <DialogActions sx={{
          justifyContent: 'center',
          pb: 2
        }}>
                    <Button variant="outlined" color="error" onClick={() => setShowpopup(false)}>
                        No
                    </Button>
                    <Button variant="contained" color="success" onClick={handlePopupSubmit}>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
        </LocalizationProvider>;
};
function mapStateToProps(state) {
  return {
    state
  };
}
export default connect(mapStateToProps)(EmployeeCostSplitup);